<template>
	<div id="app">
		<main-nav v-if="notEditing"></main-nav>
    <transition name="fade" mode="out-in">
		  <router-view></router-view>
    </transition>
	</div>
</template>

<script>
import MainNav from './components/MainNav'
export default {
    name: 'App',
    data() {
		return {
    	}
    },
    components: {
		  MainNav,
    },
    watch: {
    },
    methods: {
    },
    computed: {
      notEditing() {
        return this.$route.name != "AdminPage"
      }
    },
    mounted() {
      if (this.$isBooth) {
        console.log('BOOTH MODE')
      } else {
        console.log('WEB MODE')
      }
    }
}
</script>

<style lang="scss">
@import "./styles/variables.scss";
@import './styles/main.scss';

</style>
